import axios from 'axios'
import Cookies from 'js-cookie'

const baseURL = process.env.REACT_APP_API_SERVER_URL // Replace with API's base URL

/** Use for presign / upload-complete / multipart photo uploads (default axios timeout is 5s). */
export const MEDIA_UPLOAD_TIMEOUT_MS = 20000

// Create an Axios instance with a custom configuration
const client = axios.create({
  baseURL,
  timeout: 5000, // Desired timeout
  headers: {
    'Content-Type': 'application/json',
    // Any other common headers here
  },
  withCredentials: true,
})

// Add request interceptors if needed
// For example, to add authentication headers or request logging

// Add a request interceptor
client.interceptors.request.use(
  (config) => {
    // Modify the config before making the request
    // e.g., add authentication headers or log the request

    if (config.isPublicCall) {
      return config
    }

    // Use authToken
    const authToken = localStorage.getItem('authToken')
    const refreshToken = Cookies.get('refreshToken')
    if (authToken && !isTokenExpired(authToken)) {
      config.headers.Authorization = `Bearer ${authToken}`
    }
    // Use refreshToken
    else {
      //const refreshToken = Cookies.get('refreshToken')
      if (refreshToken && !isTokenExpired(refreshToken)) {
        config.headers.Authorization = `Bearer ${refreshToken}`
      }
      // Token expired
      else {
        // Check if session token is provided, then wait for the responsed page
        // to handle login by sessionToken
        const urlParams = new URLSearchParams(window.location.href)
        const sessionToken = urlParams.get('sessionToken')
        if (!sessionToken) {
          // Redirect to login page
          window.location.href = '/#/login'
        }
      }
    }

    // Check if the request data is a FormData object
    if (config.data instanceof FormData) {
      // Set headers for file upload
      config.headers['Content-Type'] = 'multipart/form-data'
    }

    return config
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error)
  },
)

// Add a response interceptor
client.interceptors.response.use(
  (response) => {
    // Handle the response here, if needed
    // Access response headers like response.headers
    const filteredResponse = {
      ...(response.data && { data: response.data }),
      ...(response.headers && {
        headers: {
          ...(response.headers['authorization'] && {
            authorization: response.headers['authorization'],
          }),
        },
      }),
    }

    // new authToken found --> store with localStorage
    if (filteredResponse.headers.authorization) {
      const authToken = filteredResponse.headers.authorization.replace('Bearer ', '')
      localStorage.setItem('authToken', authToken)
    }

    // refreshToken presented via cookie --> automatically stored and accessible with cookie

    return filteredResponse
  },
  (error) => {
    // Handle response errors
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Redirect to login page
      window.location.href = '/#/login'
    }
    return Promise.reject(error)
  },
)

// Function to check if a JWT token is expired
function isTokenExpired(token) {
  try {
    // We need to implement this function based on our JWT token structure
    // Typically, it involves decoding the token and checking the expiration claim
    // This is a simplified example and may not cover all cases
    if (!token) {
      return true
    }

    const payload = JSON.parse(atob(token.split('.')[1]))
    const expiration = payload.exp * 1000 // Convert to milliseconds

    return expiration < Date.now()
  } catch (error) {
    return true
  }
}

// Export the Axios instance for making API calls
export { client }
